import React, { Component } from 'react'

export default class FooterPostContent extends Component {
  render() {
    return (
      <footer>
        <ul className="social">
          <li>
            <a href="" className="sociais" title="Facebook">
              <i className="fa fa-facebook"></i>
            </a>
          </li>
          <li>
            <a href="" className="sociais" title="Twitter">
              <i className="fa fa-twitter"></i>
            </a>
          </li>
          <li>
            <a href="" className="sociais" title="Google">
              <i className="fa fa-google-plus"></i>
            </a>
          </li>
          <li>
            <a href="" className="sociais" title="Link">
              <i className="fa fa-link"></i>
            </a>
          </li>
        </ul>
      </footer>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/atoms/footer-post-content.js